
<div class="error-page">
    <!-- <h1>{{errorMessage}}</h1> -->
    <ng-lottie style="opacity: 0.6;" width="800px" height="400px" [options]="page_not_found"></ng-lottie>
</div>
